<template>
  <div class="answers">
    <div v-if="type === 'single' || type === 'multiple'" class="answers__type answers__type_choice">
      <answer
        v-for="(item, index) in answers"
        :key="index"
        class="choice-answer"
        :item="item"
        :type="type"
        :answer_focus="answer_focus"
        :is-dropout-module-enabled="isDropoutModuleEnabled"
        @set_answer="set_answer"
        @del_answer="del_answer"
        @setCutOptioin="setCutOptioin"
      />

      <div class="choice-answer">
        <div class="choice-answer__circle">
          <vcheckbox v-if="type === 'multiple'" class="answer" />
        </div>

        <div class="choice-answer__circle">
          <vcircle v-if="type === 'single'" class="answer" />
        </div>

        <div class="other" :class="{ 'has-error': !answers || !answers.length }">
          <div class="other__add-type other__type" @click="add_answer('default')">
            {{ $tr('vacancy.preferences.application.addAnswers1') }}
            <span v-if="!has_other && allowCutAnswer && isDropoutModuleEnabled">,&nbsp;</span>
          </div>

          <div v-if="!has_other">
            <span v-if="!allowCutAnswer || !isDropoutModuleEnabled" class="regular-text">
              {{ $tr('vacancy.preferences.application.addAnswers2') }}
            </span>

            <span class="other__type" @click="add_answer('other')">
              {{ $tr('vacancy.preferences.application.addAnswers3', {}, { locale: vacancyLanguage }) }}
            </span>
          </div>

          <div v-if="allowCutAnswer && isDropoutModuleEnabled">
            <span class="regular-text">
              {{ $tr('vacancy.preferences.application.addAnswers2') }}
            </span>

            <span class="other__type" @click="add_answer('cutAnswer')">
              {{ $tr('vacancy.preferences.application.addAnswers4') }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="type === 'date' && isDropoutModuleEnabled && isDropDateLoaded && dateDropoutModel"
      class="answers__type answers__type_date"
    >
      <vchecklabel
        v-model="isDropOut"
        class="rates-checkbox"
        :label="$tr('vacancy.preferences.application.dateDropoutCheckbox')"
      />
      <div>
        <vdate-range-slider
          :date-start="dropoutDateMin"
          :date-end="dropoutDateMax"
          :disabled="!isDropOut"
          :date-inner="dateInner"
          @set_valid_date_min="set_valid_date_min"
          @set_valid_date_max="set_valid_date_max"
          @setSelectedRange="setSelectedRange"
          @changeDateStart="changeDropoutDateMin"
          @changeDateEnd="changeDropoutDateMax"
        />
      </div>
    </div>

    <div v-if="type === 'file'" class="answers__type answers__type_file">
      <label class="file-title">{{ $tr('vacancy.preferences.fileUploadLabel') }}</label>

      <div class="file-wrapper">
        <span>{{ $tr('vacancy.preferences.application.fileHolder') }}</span>

        <div class="actions">
          <icon-upload :width="'31px'" :height="'20px'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Answer from './Answer.vue';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Answers',

  components: {
    Answer
  },

  props: {
    answers: {
      type: Array,
      default: () => []
    },

    question: {
      type: Object,
      default: () => {}
    },

    type: {
      type: String,
      default: ''
    },

    isDateMinChanged: Boolean
  },

  data() {
    return {
      answer_focus: false,
      dateStart: '',
      dateEnd: '',
      dataCutMode: null,
      isDateInner: true,
      isDateInnerChanged: null,
      dropoutDateMin: null,
      dropoutDateMax: null,
      isDropDateLoaded: false,
      dateDropoutModel: null
    };
  },

  computed: {
    ...mapState('vacancy_new', { vacancyLanguage: state => state.item.language.code || 'ru' }),

    ...mapGetters('vacancy_new', {
      modules: 'modules/list'
    }),

    activedModules() {
      return this.modules.filter(item => item.is_active);
    },

    isDropoutModuleEnabled() {
      if (!this.activedModules || !this.activedModules.length) {
        return false;
      }

      return !!this.activedModules.find(item => item.id === 'survey-screening');
    },

    answers_empty() {
      if (this.type === 'open' || this.type === 'date' || this.type === 'file' || this.type === 'enumeration') {
        return false;
      }
      return this.answers.some(item => item.content.length === 0) || !this.answers.length;
    },

    has_other() {
      return this.answers ? this.answers.some(el => el.type === 'other') : false;
    },

    allowCutAnswer() {
      return this.type === 'single' || this.type === 'multiple' || this.type === 'date';
    },

    dateInner: {
      get() {
        if (this.isDateInnerChanged !== null) {
          return this.isDateInnerChanged;
        }

        return this.isDateInner;
      },

      set(val) {
        this.isDateInnerChanged = val;
      }
    },

    isDropOut: {
      get() {
        if (this.dataCutMode !== null) {
          return this.dataCutMode;
        }

        return this.question ? !!(this.question.dropout_date_max || this.question.dropout_date_min) : false;
      },

      set(val) {
        this.dataCutMode = val;
        this.$emit('setDropoutDate', val);
        if (!val) {
          this.checkDropoutDates(null, null, this.dateInner);
        } else {
          this.checkDropoutDates(this.dropoutDateMin, this.dropoutDateMax, this.dateInner);
        }
      }
    }
  },

  watch: {
    answers_empty: {
      immediate: true,
      handler(val) {
        this.$store.commit('vacancy/application/set_answers_empty', val);
      }
    }
  },

  beforeMount() {
    if (this.question) {
      this.dateDropoutModel = Object.assign(
        {},
        {
          dropout_date_min: this.question.dropout_date_min,
          dropout_date_max: this.question.dropout_date_max,
          is_indicated_dates: this.question.is_indicated_dates
        }
      );
      if (!this.dateDropoutModel.dropout_date_min && !this.dateDropoutModel.dropout_date_max) {
        this.isDateInner = false;
        this.isDropDateLoaded = true;
        return;
      }

      this.isDateInner = !!this.dateDropoutModel.is_indicated_dates;

      if (this.dateDropoutModel.dropout_date_max && this.dateDropoutModel.dropout_date_min) {
        const dateMin = this.$moment(this.dateDropoutModel.dropout_date_min, 'YYYY-MM-DD').format('DD-MM-YYYY');
        const dateMax = this.$moment(this.dateDropoutModel.dropout_date_max, 'YYYY-MM-DD').format('DD-MM-YYYY');
        if (this.$moment(dateMax, 'DD-MM-YYYY').diff(this.$moment(dateMin, 'DD-MM-YYYY'), 'day') < 0) {
          this.isDateInner = true;
          this.dropoutDateMin = this.$moment(this.dateDropoutModel.dropout_date_max, 'YYYY-MM-DD').format('DD-MM-YYYY');
          this.dropoutDateMax = this.$moment(this.dateDropoutModel.dropout_date_min, 'YYYY-MM-DD').format('DD-MM-YYYY');
        } else {
          this.isDateInner = false;
          this.dropoutDateMin = this.$moment(this.dateDropoutModel.dropout_date_min, 'YYYY-MM-DD').format('DD-MM-YYYY');
          this.dropoutDateMax = this.$moment(this.dateDropoutModel.dropout_date_max, 'YYYY-MM-DD').format('DD-MM-YYYY');
        }
      } else if (this.dateDropoutModel.dropout_date_max) {
        if (!this.dateDropoutModel.dropout_date_min) {
          if (this.isDateInner) {
            this.dropoutDateMax = null;
            this.dropoutDateMin = this.$moment(this.dateDropoutModel.dropout_date_max, 'YYYY-MM-DD').format(
              'DD-MM-YYYY'
            );
          } else {
            this.dropoutDateMax = this.$moment(this.dateDropoutModel.dropout_date_max, 'YYYY-MM-DD').format(
              'DD-MM-YYYY'
            );
          }
        }
      } else if (this.dateDropoutModel.dropout_date_min) {
        if (!this.dateDropoutModel.dropout_date_max) {
          if (this.isDateInner) {
            this.dropoutDateMin = null;
            this.dropoutDateMax = this.$moment(this.dateDropoutModel.dropout_date_min, 'YYYY-MM-DD').format(
              'DD-MM-YYYY'
            );
          } else {
            this.dropoutDateMin = this.$moment(this.dateDropoutModel.dropout_date_min, 'YYYY-MM-DD').format(
              'DD-MM-YYYY'
            );
          }
        }
      }
    }
    this.isDropDateLoaded = true;
    // if (this.question.dropout_date_max) {
    //         if (this.dateInner) {
    //           tempVal = moment(this.question.dropout_date_max, 'YYYY-MM-DD').format('DD-MM-YYYY');
    //         } else {
    //           tempVal = moment(this.question.dropout_date_min, 'YYYY-MM-DD').format('DD-MM-YYYY');
    //         }
    //       }

    //       if (this.dateInner) {
    //         tempVal = null;
    //       } else {
    //         tempVal = moment(this.question.dropout_date_min, 'YYYY-MM-DD').format('DD-MM-YYYY');
    //       }
    //       this.$store.commit('vacancy/application/setDropoutDateMax', {
    //         question_id: this.question.id,
    //         dropout_date_min: tempVal
    //       });
  },

  methods: {
    changeDropoutDateMin(val) {
      this.dropoutDateMin = val;
      this.checkDropoutDates(val, this.dropoutDateMax, this.dateInner);
    },

    changeDropoutDateMax(val) {
      this.dropoutDateMax = val;
      this.checkDropoutDates(this.dropoutDateMin, val, this.dateInner);
    },

    setSelectedRange(val) {
      this.dateInner = val;
      this.checkDropoutDates(this.dropoutDateMin, this.dropoutDateMax, val);
    },

    set_valid_date_min(v) {
      this.$emit('changeDateValidMin', v);
    },

    set_valid_date_max(v) {
      this.$emit('changeDateValidMax', v);
    },

    checkDropoutDates(dropout_date_min, dropout_date_max, is_indicated_dates) {
      if (!dropout_date_min && !dropout_date_max) {
        this.$emit('changeDropoutDateMin', {
          dropout_date_min: null
        });
        this.$emit('changeDropoutDateMax', {
          dropout_date_max: null
        });
        return;
      }

      if (dropout_date_max && dropout_date_min) {
        const dateMin = this.$moment(dropout_date_min, 'DD-MM-YYYY');
        const dateMax = this.$moment(dropout_date_max, 'DD-MM-YYYY');
        if (
          this.$moment(dateMax, 'DD-MM-YYYY').diff(this.$moment(dateMin, 'DD-MM-YYYY'), 'day') < 0 ||
          is_indicated_dates
        ) {
          this.$emit('changeDropoutDateMin', {
            dropout_date_min: this.$moment(dropout_date_max, 'DD-MM-YYYY').format('YYYY-MM-DD')
          });
          this.$emit('changeDropoutDateMax', {
            dropout_date_max: this.$moment(dropout_date_min, 'DD-MM-YYYY').format('YYYY-MM-DD')
          });
          this.$emit('setSelectedRange', { is_indicated_dates: true });
        } else {
          this.$emit('changeDropoutDateMin', {
            dropout_date_min: this.$moment(dropout_date_min, 'DD-MM-YYYY').format('YYYY-MM-DD')
          });
          this.$emit('changeDropoutDateMax', {
            dropout_date_max: this.$moment(dropout_date_max, 'DD-MM-YYYY').format('YYYY-MM-DD')
          });
          this.$emit('setSelectedRange', { is_indicated_dates: false });
        }
      } else if (dropout_date_max) {
        if (!dropout_date_min) {
          if (is_indicated_dates) {
            this.$emit('changeDropoutDateMin', {
              dropout_date_min: this.$moment(dropout_date_max, 'DD-MM-YYYY').format('YYYY-MM-DD')
            });
            this.$emit('changeDropoutDateMax', { dropout_date_max: null });
            this.$emit('setSelectedRange', { is_indicated_dates });
          } else {
            this.$emit('changeDropoutDateMin', { dropout_date_min: null });
            this.$emit('changeDropoutDateMax', {
              dropout_date_max: this.$moment(dropout_date_max, 'DD-MM-YYYY').format('YYYY-MM-DD')
            });
            this.$emit('setSelectedRange', { is_indicated_dates });
          }
        }
      } else if (dropout_date_min) {
        if (!dropout_date_max) {
          if (is_indicated_dates) {
            this.$emit('changeDropoutDateMin', { dropout_date_min: null });
            this.$emit('changeDropoutDateMax', {
              dropout_date_max: this.$moment(dropout_date_min, 'DD-MM-YYYY').format('YYYY-MM-DD')
            });
            this.$emit('setSelectedRange', { is_indicated_dates });
          } else {
            this.$emit('changeDropoutDateMin', {
              dropout_date_min: this.$moment(dropout_date_min, 'DD-MM-YYYY').format('YYYY-MM-DD')
            });
            this.$emit('changeDropoutDateMax', { dropout_date_max: null });
            this.$emit('setSelectedRange', { is_indicated_dates });
          }
        }
      }
    },

    add_answer(v) {
      if (v === 'other') {
        this.$emit('add_answer', v);
      } else if (v === 'cutAnswer') {
        this.$emit('add_drop_answer', v);
      } else if ((v === 'default', this.has_other)) {
        this.$emit('add_answer', 'other-default');
        this.answer_focus = true;
      } else if ((v === 'default', !this.has_other)) {
        this.$emit('add_answer', v);
        this.answer_focus = true;
      }
    },

    del_answer(v) {
      if (v.type === 'other') {
        this.other = false;
      }
      this.$emit('del_answer', v.id);
    },

    set_answer({ v, answ_id }) {
      this.$emit('set_answer', {
        id: answ_id,
        value: v
      });
    },

    setCutOptioin(model) {
      this.$emit('setCutOptioin', {
        id: model.item.id,
        is_dropout: model.isTrue
      });
    },

    answer_error(v) {
      if (v === '') {
        return this.$tr('common.requiredField');
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.answers {
  &__type {
    &_choice {
      margin-top: 7px;

      .choice-answer {
        display: flex;
        align-items: flex-start;
        margin-bottom: 16px;
        position: relative;

        &__circle {
          height: 39px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .other {
          width: 100%;
          margin-left: 20px;
          padding: 10px;
          border-bottom: 1px solid #d2d6e0;
          color: #9faab6;
          display: flex;
          align-items: center;
          font-size: 15px;

          &.has-error {
            border-color: #f65046;
          }

          &__type {
            cursor: pointer;
            margin-right: 4px;
            font-weight: 500;
            position: relative;

            &:hover {
              color: #607182;
            }
          }

          &__add-type {
            position: relative;

            &:hover {
              color: #607182;
            }
          }

          span {
            font-weight: 500;
          }
        }
      }

      .answer {
        border: 2px solid #dadada;
        height: 39px;
      }
    }

    &_date {
      margin-top: 19px;
      position: relative;

      .date__range {
        width: 150px;
        padding: 10px 20px;
        border: 1px solid #d2d6e0;
        color: #9faab6;
      }

      ::v-deep {
        .vcheckbox_label .checkbox_label {
          margin-left: 10px;
        }
      }
    }

    &_file {
      margin-top: 12px;

      .file-title {
        font-size: 15px;
        line-height: 22px;
        color: #233346;
      }

      .file-wrapper {
        position: relative;
        width: 100%;
        margin-top: 4px;
        border: 1px solid #d2d6e0;
        padding: 11px;
        border-radius: 2px;
        color: #9faab6;
        font-size: 15px;

        .actions {
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translateY(-50%);
        }
      }
    }
  }
}

.regular-text {
  font-weight: 400 !important;
}
</style>
